import React from 'react'
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import SearchSubjects from '../../../../search_subjects/subjects/index'

class CreateLeadSubject extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      adding: false,
      subject_name: ''
    }
  }

  onToggleAddSubject = () => {
    this.setState({adding: !this.state.adding})
  }

  onSubjectChange = (value) => {
    this.setState({subject_name: value})
  }

  onSubjectSelect = (subject) => {
    this.setState({adding: false})
    this.props.store.emit('lead:settings:subjects:add', this.props.lead.id, subject)
  }

  render() {
    return (
      <div className="grid gap-4">
        <div className="flex justify-end">
          <Button variant="outline" size="sm" onClick={this.onToggleAddSubject}>
            <Plus className="size-3.5"/> Add Subject
          </Button>
        </div>
        {this.state.adding ?
          <div className="grid gap-2">
            <Label>Search Subject</Label>
            <SearchSubjects
              value={this.state.subject_name}
              country_code={this.props.lead.country_code}
              subject_category_name={this.props.lead.settings.subject_category_name}
              onChange={this.onSubjectChange}
              onSelect={this.onSubjectSelect}
            />
          </div>
          : null
        }
      </div>
    )
  }
}

export default CreateLeadSubject
